"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yappyPayment = exports.clavePayment = exports.achPayment = exports.cashPayment = exports.broker = exports.creditCard = void 0;
exports.creditCard = 'TCR';
exports.broker = 'AGE';
exports.cashPayment = 'DCW';
exports.achPayment = 'ACH';
exports.clavePayment = 'CLA';
exports.yappyPayment = 'YAP';
//# sourceMappingURL=paymentTypes.js.map